import React from "react"
import clsx from "clsx"
import { FaSpinner } from "react-icons/fa6"

import classes from "./Spinner.module.scss"

const Spinner = (props) => {
  const { className, ...otherProps } = props

  return (
    <FaSpinner
      className={clsx(classes["spinner"], className)}
      {...otherProps}
    />
  )
}

export default Spinner